import { PropsWithChildren, ReactNode } from 'react';
import {
	PageListHeaderActions,
	PageHeaderActionsLeft,
	PageHeaderActionsRight,
	PageListHeaderContainer,
	PageHeaderCount,
	PageListHeaderTitleContainer,
	PageListTitle,
} from 'shared/_components/page/styles';

type PageHeaderProps = PropsWithChildren<{
	count?: number;
	actionsLeft?: ReactNode;
	actionsRight?: ReactNode;
}>;

export default function PageListHeader(props: PageHeaderProps) {
	const { children, count, actionsLeft, actionsRight } = props;

	return (
		<PageListHeaderContainer>
			<PageListHeaderTitleContainer>
				<PageListTitle>{children}</PageListTitle>
				{!!count && <PageHeaderCount>({count})</PageHeaderCount>}
			</PageListHeaderTitleContainer>
			{!!(actionsLeft || actionsRight) && (
				<PageListHeaderActions>
					{!!actionsLeft && <PageHeaderActionsLeft>{actionsLeft}</PageHeaderActionsLeft>}
					{!!actionsRight && <PageHeaderActionsRight>{actionsRight}</PageHeaderActionsRight>}
				</PageListHeaderActions>
			)}
		</PageListHeaderContainer>
	);
}
